<ng-container *ngIf="(showLabelAboveInput$ | async) === true">
  <label [id]="labelId" [innerHTML]="label" class="emperor-ui-long-label" [for]="id"></label>
</ng-container>

<mat-form-field
  appearance="outline"
  class="emperor-ui-full-width emperor-ui-text-input"
  [ngClass]="{
    'emperor-ui-long-label': (showLabelAboveInput$ | async) === true,
    'emperor-ui-label-with-placeholder': !!placeholder,
    'has-hint': !!hint,
    'has-hint-with-icon': !!hintWithIcon
  }"
>
  <mat-label
    *ngIf="(showLabelAboveInput$ | async) === false || !!placeholder"
    [attr.id]="(showLabelAboveInput$ | async) === false ? labelId : null"
    >{{ !!placeholder ? placeholder : label }}
  </mat-label>
  <textarea
    matInput
    [id]="id || ''"
    [formControl]="control"
    [attr.aria-label]="ariaLabel ? ariaLabel : sanitizedLabelText"
    [attr.aria-labelledby]="emperorInputAriaLabeledBy"
    [attr.data-test]="qaAttributeHook"
  >
  </textarea>
  <mat-error emperorErrorHandler [errorText]="errorText" [errorMessageMap]="errorMessageMap" [id]="code || ''"></mat-error>
  <mat-hint *ngIf="!!hint && !hintWithIcon" [innerHtml]="hint"></mat-hint>
  <mat-hint *ngIf="!!hintWithIcon">
    <emperor-hint-with-icon [hintWithIcon]="hintWithIcon"></emperor-hint-with-icon>
  </mat-hint>
</mat-form-field>
